<template>
  <div class="error py-5 px-3">
    {{msg}}
  </div>
</template>

<script>
export default {
  name: 'Error',
  props: {
    msg: String,
  },
};
</script>

<style scoped lang="scss">
@import '@/assets/scss/common.scss';
.error {
  background-color: #F5F5F5;
  border-radius: 7px;
  color: #d63232;
  font-size: 15px;
  text-align: center;
  @include media-breakpoint-down(lg) {
    font-size: 12px;
  }
}
</style>
